export default __webpack_public_path__ + "static/media/icon.bdf76c40.jpg";